import React, { Component } from 'react';
import Header from '../header';
import Footer from '../footer';
import './index.less';

/**
 * 关于我们
 */
class About extends Component {
    render() {
        return (
            <div className="about">
                <Header />
                <div className="about__wrapper">
                    关于我们
                </div>
                <Footer />
            </div>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/about/index.js